import {useIntl} from 'react-intl'
import {useQuery} from '@tanstack/react-query'
import {fetchTaxRate} from '../utils/taxation'
import {useAccessToken} from '@salesforce/commerce-sdk-react'

const useTaxRate = (queryOptions = {}) => {
    const {locale} = useIntl()
    const {getTokenWhenReady} = useAccessToken()

    return useQuery({
        ...queryOptions,
        queryKey: ['app', locale],
        queryFn: () => fetchTaxRate({locale, getTokenWhenReady})
    })
}

export default useTaxRate
